import { useState } from "react";
import { Button, Modal, Select, message } from "antd";
import { useProjectOptions } from "projects/queries";
import { useAttachEligibilityCheck } from "eligibility/queries";

interface Props {
  checkId: string;
  organizationId?: string;
  onSaved?: () => void;
}

// Attaches a completed eligibility check to a project. The project picker searches
// the org's projects (min 3 chars, same as the rest of the app).
export const SaveToProject = ({ checkId, organizationId, onSaved }: Props) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [projectId, setProjectId] = useState<string>();

  const { data: options, isFetching } = useProjectOptions(organizationId, search);
  const attach = useAttachEligibilityCheck(organizationId);

  const onOk = () => {
    if (!projectId) {
      message.warning("Select a project first.");
      return;
    }
    attach.mutate(
      { id: checkId, projectId },
      {
        onSuccess: () => {
          message.success("Saved to project.");
          setOpen(false);
          setProjectId(undefined);
          setSearch("");
          onSaved?.();
        },
        onError: () => message.error("Could not save to project."),
      }
    );
  };

  return (
    <>
      <Button onClick={() => setOpen(true)}>Save to Project</Button>
      <Modal
        title="Save to Project"
        open={open}
        onOk={onOk}
        onCancel={() => setOpen(false)}
        confirmLoading={attach.isPending}
        okText="Save"
      >
        <Select
          showSearch
          style={{ width: "100%" }}
          placeholder="Search projects…"
          aria-label="Project"
          filterOption={false}
          loading={isFetching}
          notFoundContent={search.length < 3 ? "Type at least 3 characters" : null}
          onSearch={setSearch}
          onChange={(v) => setProjectId(v as string)}
          value={projectId}
          options={options}
        />
      </Modal>
    </>
  );
};
